import { ChevronRightIcon, HelpCircleIcon, Text } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import styles from './SmartSearchQuestionList.module.scss';

type SmartSearchQuestionListProps = {
  title: string;
  questions: { key: string | number; question: string }[];
  onClickQuestion: (question: string) => void;
  bordered?: boolean;
};

const SmartSearchQuestionList = ({ title, questions, onClickQuestion, bordered }: SmartSearchQuestionListProps) => {
  if (questions.length === 0) return null;

  return (
    <div className={clsx(styles['question-list'], bordered && styles['bordered'])}>
      <Text className={styles['title']} size="small" color="tertiary">
        {title}
      </Text>
      <ul className={styles['list']}>
        {questions.map((item) => (
          <li key={item.key}>
            <button className={styles['item']} type="button" onClick={() => onClickQuestion(item.question)}>
              <div className={styles['item-left']}>
                <HelpCircleIcon size={16} color="gray600" />
                <Text size="large" color="secondary">
                  {item.question}
                </Text>
              </div>
              <ChevronRightIcon size={24} color="gray600" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SmartSearchQuestionList;
